<template>
    <b-form-row>
        <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

            <b-form @submit.prevent="save">
                <b-card bg-variant="light">

                    <lg-form-input :disabled="isViewMode" invalidFeedback="Informe um parecer jurídico válido!" description=" "
                        :error="$v.form.parecerJuridico" v-model="form.parecerJuridico" label="Parecer Jurídico:*"
                        cols="12" />

                    <lg-form-input :disabled="isViewMode" invalidFeedback="Informe um parecer técnico válido!" description=" "
                        :error="$v.form.parecerTecnico" v-model="form.parecerTecnico" label="Parecer Técnico:*"
                        cols="12" />


                    <b-form-row>

                        <b-col cols="3"></b-col>
                        <b-col cols="6" class="text-center">
                            <b-button id="salvarLocalCadastro" class=" my-2" size="sm" pill variant="success"
                                @click="save">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvarLocalCadastro" title="Salvar"></b-tooltip>

                            </b-button>

                            <b-button id="cancelarLocalCadastro" class=" my-2 ml-2" size="sm" pill variant="danger"
                                @click="cancelar">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelarLocalCadastro" title="Cancelar"></b-tooltip>

                            </b-button>
                        </b-col>
                        <b-col cols="3"></b-col>

                    </b-form-row>


                </b-card>

            </b-form>
        </b-modal>
    </b-form-row>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { FormResourceMixin } from "@/core/mixins/resource";

export default {
    components: {
        LgFormInput,
    },
    props: {
        isViewMode: {
            type: Boolean,
            default: false
        },

        ataSolicitacao: {
            type: Number,
            default: null,
        },
        id: Number,
        prefix: {
            type: String,
            default: "",
        },
    },
    mixins: [FormResourceMixin],
    validations: {
        form: {
            parecerJuridico: { required },
            parecerTecnico: { required },

        },
    },
    data() {
        return {
            showModal: true,
            title: "Parecer Solicitação",
            form: {
                descricao: "",
            },
        };
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/parecer-ata-solicitacao-atualizacao-valor`);
    },
    async mounted() {
        if (this.isViewMode) {
            const { data } = await this.$service.get("buscar-por-ata/" + this.ataSolicitacao);
            this.form = data;
        }
    },
    methods: {
        async save() {
            if (!this.formIsValid) {
                this.$v.$touch();
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos de cadastro.",
                });
                return;
            }

            this.form.ata = this.ataSolicitacao;
            try {
                await this.$saveResource(this.form);
            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error,
                });

            }
            this.cancelar();
        },
        cancelar() {
            this.$emit("close");
        },

    },
};
</script>
